import React from "react";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";

import AttachmentsTab from "../../LoanDetails/AttachmentsTab";

const AttachmentModal = ({ attach, setAttach }) => {
  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <AttachmentsTab />
          </ErrorBoundary>
        }
        title="Attachments"
        toShow={attach}
        closeEventHandler={() => {
          setAttach(false);
        }}
      />
    </div>
  );
};

export default AttachmentModal;
